
import { useMemo } from 'react';
import { MenuItem } from '@/types/menu';

export const useMenuItems = (menuItems: MenuItem[], categories: string[]) => {
  const categorizedItems = useMemo(() => {
    const itemsByCategory = new Map<string, MenuItem[]>();
    
    categories.forEach(category => {
      const items = menuItems.filter(item => 
        item.category === category && !item.hidden
      );
      if (items.length > 0) {
        itemsByCategory.set(category, items);
      }
    });
    
    return itemsByCategory;
  }, [menuItems, categories]);

  return { categorizedItems };
};
